import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { CoverageDocument } from "@graphql/api";
import Document from "./Document";

interface Props {
  documents: CoverageDocument[];
  residentId: string;
}

export default function DocumentsList({ documents, residentId }: Props) {
  if (!documents.length) {
    return (
      <Typography variant="subtitle1">
        Coverage has no documents assigned.
      </Typography>
    );
  }
  return (
    <Stack direction="column" spacing={2}>
      {documents.map((document) => (
        <Document
          key={document.id}
          document={document}
          residentId={residentId}
        />
      ))}
    </Stack>
  );
}
